import { careerPageRoute } from 'lib/constants/routes'
import _useTranslation from 'lib/hooks/_useTranslation'
import Link from 'next/link'
import { Body1 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import styled, { css } from 'styled-components'

const Container = styled.div<{ hideOnScrollDownMobile?: boolean }>`
    background: linear-gradient(90deg, #3f51b5 0%, #6c3ebc 100%);
    border-width: 0px 1px 1px 0px;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0.15);
    border-radius: 0 0 16px 16px;
    padding: 6px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    p {
        font-family: var(--font-inter);
        font-size: 12px;
        font-weight: 350;
        line-height: 16px;
        letter-spacing: 0.5px;
        color: ${theme.colors.white};
        text-align: center;
    }
    position: fixed;
    top: var(--navbar-height);
    cursor: pointer;
    left: 50%;
    transform: translateX(-50%);
    z-index: 52;
    transition: transform 0s ease-in-out;
    @media (max-width: 750px) {
        padding: 4px 6px;
        width: 300px;
        top: 0;
        ${({ hideOnScrollDownMobile }) =>
            hideOnScrollDownMobile
                ? css`
                      transform: translateX(-50%) translateY(70px);
                  `
                : css`
                      transform: translateX(-50%) translateY(52px);
                  `}
    }
`

interface Props {
    hideOnScrollDownMobile?: boolean
}

const SeriesBAnnouncementBanner = ({ hideOnScrollDownMobile }: Props) => {
    const { t } = _useTranslation('common')

    const shouldShowBanner = () => {
        const now = new Date()
        const cetTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Berlin' }))

        const isTargetDate = cetTime.getFullYear() === 2025 && cetTime.getMonth() === 5 && cetTime.getDate() === 13

        const isAfterCutoff = cetTime.getHours() >= 8

        return isTargetDate && isAfterCutoff
    }

    if (!shouldShowBanner()) {
        return null
    }

    return (
        <Link href={careerPageRoute} passHref prefetch={false}>
            <Container hideOnScrollDownMobile={hideOnScrollDownMobile}>
                <Body1>
                    {t('common/seriesBAnnouncementBannerText', 'We just raised €27mio, check our open roles here')}
                </Body1>
            </Container>
        </Link>
    )
}

export default SeriesBAnnouncementBanner
